<template>
	<div style="width: 100%;">
		<div
			style="width: 210px;padding-top: 9px;padding-bottom: 9px;font-size: 14px;margin: auto;text-align: center;background-color: #aaa7a7;border-radius: 10px 10px 0px 0px;border-bottom: solid 1px #c6c6c6;">
			{{selectdItem.compontChildren[0].name + '设置'}}
		</div>
		<div :style="{
			marginTop: index != 0? '10px':'10px'
		}" style="width: 100%;" v-for="(item,index) in getList()" :key="index">
			<div style="margin-left: 7px;">
				{{item.languageName}}
			</div>
			<div style="margin: 7px;">
				<el-input size="mini" type="textarea" :rows="4" v-model="item.text" placeholder="请输入内容"></el-input>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			compontentStyle: {
				type: Object,
				default: () => {
					return {}
				}
			},
			systemConfig: {
				type: Object,
				default: () => {
					return {}
				}
			},
			selectdItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},
		mounted() {
			console.log('selectdItemselectdItem', this.selectdItem)
		},
		methods: {
			getList() {
				let arr = []
				let topItem;
				this.selectdItem.compontChildren[0].data.text.list.forEach(item => {
					this.systemConfig.locale_list.forEach(langItem => {
						if (item.language == this.systemConfig.locale) {
							topItem = item

						} else {
							if (item.language == langItem.code) {
								arr.push(item)
							}
						}
					})
				})
				arr.unshift(topItem)
				console.log('arr', arr)
				return arr
			},
		}

	}
</script>

<style>
</style>